import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=db0c4220&scoped=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=js"
export * from "./CustomerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0c4220",
  null
  
)

export default component.exports